import Vue from 'vue'
import App from './App'
import store from '@shared/store'
import router from '@core/router'
import i18n from '@shared/language'
import hit_post from '@shared/plugins/plugin.js'
import CKEditor from '@ckeditor/ckeditor5-vue'

import 'document-register-element/build/document-register-element'
import vueCustomElement from 'vue-custom-element'

Vue.config.productionTip = false

Vue.use(vueCustomElement)
Vue.use(CKEditor)

var api_url = 'https://api.hitklick.com/'
var www_url = 'https://hitklick.com'

if (process.env.NODE_ENV == 'development') {
  api_url = 'http://localhost:3001'
  www_url = 'http://localhost:3000'
}


Vue.use(hit_post, {
  hit_url: process.env.VUE_APP_API_URL,
  flix_url: process.env.VUE_APP_API_URL,
  api_url: api_url,
  www_url: www_url,
  lang: 'de'
}
)

App.i18n = i18n
App.store = store
App.router = router
Vue.customElement('hit-core', App)
